export enum LOCALES {
    en = "en",
    de = "de",
    it = "it",
}

export type ILocales = keyof typeof LOCALES;
